export default {
  notFound: "Das Formular/der Fragebogen wurde nicht gefunden!",
};
